/* global global */
import { FRONTEND_ROOT } from "../config/constants";

let [proto, domain] = FRONTEND_ROOT.split("://");
domain = domain.split(":")[0];
domain = domain === "localhost" ? "" : domain;

export function setCookieParams() {
  return {
    domain,
    secure: proto === "https",
  };
}

export function removeCookieParams() {
  return { domain };
}

export function getLastSeenCookieName(slug, streamType) {
  return `lastSeen_${slug}_${streamType}`;
}

export function getSecondsIn({
  days = 0,
  hours = 0,
  minutes = 0,
  seconds = 0,
}) {
  return days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60 + seconds;
}
